import { WidgetDirectivesRepository } from '@framework/engine/schema/directives/WidgetDirectivesRepository.ts';
import { WidgetRepository } from '@framework/engine/schema/widgets/repository/WidgetRepository.ts';
import { AddressBookWidgetType } from '#features/packages/common-web/src/address-book/widgets/address-book/AddressBookWidget.type.tsx';
import { initThemeWidgetRepository } from '#theme';
import { BurdensLogic } from '../schema/burdens/BurdensLogic.ts';
import { CustomPropertiesDirectiveType } from './directives/custom-properties/CustomPropertiesDirective.type.tsx';
import { IntegrableDirectiveType } from './directives/integrable/IntegrableDirective.type.tsx';
import { MetadataDirectiveType } from './directives/metadata/MetadataDirective.type.tsx';
import { OmissisDirectiveType } from './directives/omissis/OmissisDirective.type.tsx';
import { OutcomeActionDirectiveType } from './directives/outcome-action/OutcomeActionDirective.type.tsx';
import { SubjectDataDirectiveType } from './directives/subject-data/SubjectDataDirective.type.tsx';
import { TableSaveDirectiveType } from './directives/table-save/TableSaveDirective.type.tsx';
import { BurdenWidgetType } from './widgets/burden/BurdenWidget.type.tsx';
import { CompetenceWidgetType } from './widgets/competence/CompetenceWidget.type.tsx';
import { DownloadWidgetType } from './widgets/download/DownloadWidget.type.tsx';
import { EmailVerificationWidgetType } from './widgets/email-verification/EmailVerificationWidget.type.tsx';
import { ImageWidgetType } from './widgets/image/ImageWidget.type.tsx';
import { MapWidgetType } from './widgets/map/MapWidget.type.tsx';
import { ModuleTriggerWidgetType } from './widgets/module-trigger/ModuleTriggerWidget.type.tsx';
import { ProvinceWidgetType } from './widgets/province/ProvinceWidget.type.tsx';
import { SectionWidgetType } from './widgets/section/SectionWidget.type.tsx';
import { UploadWidgetType } from './widgets/upload/UploadWidget.type.tsx';

export const initCommonWebWidgetRepository = () => {
  console.log('@framework/common-web: initCommonWebWidgetRepository');
  /**
   * Widget per selezionare la Competenza
   */
  if (process.env.BUILD_FLAGS_COMPETENCES != 'false') {
    WidgetRepository.register(CompetenceWidgetType);
  }
  /**
   * Oneri
   */
  if (BurdensLogic.isVisible()) {
    WidgetRepository.register(BurdenWidgetType);
  }
  /**
   * Upload
   */
  WidgetRepository.register(UploadWidgetType);
  /**
   * Email Verification
   */
  WidgetRepository.register(EmailVerificationWidgetType);
  /**
   * Download File
   */
  WidgetRepository.register(DownloadWidgetType);
  /**
   * Immagine
   */
  WidgetRepository.register(ImageWidgetType);
  /**
   * Sezione
   */
  WidgetRepository.register(SectionWidgetType);
  /**
   * Mappe
   */
  WidgetRepository.register(MapWidgetType);
  /**
   * Attivazione moduli
   */
  WidgetRepository.register(ModuleTriggerWidgetType);
  /**
   * Città e Provincia
   */
  WidgetRepository.register(ProvinceWidgetType);

  /**
   * Rubrica (Address Book)
   */
  if (BuildFlags.BUILD_FLAGS_ADDRESS_BOOK) {
    WidgetRepository.register(AddressBookWidgetType);
  }

  // Direttive
  /**
   * Funzionalità del "salva in tabella"
   */
  WidgetDirectivesRepository.register(TableSaveDirectiveType);
  /**
   * Dati del titolare della richiesta
   */
  WidgetDirectivesRepository.register(SubjectDataDirectiveType);
  /**
   * Gestione dell'opzionalità delle sezioni in bse all'esito selezionato
   */
  WidgetDirectivesRepository.register(OutcomeActionDirectiveType);
  /**
   * Esportazione dei metadati
   */
  WidgetDirectivesRepository.register(MetadataDirectiveType);
  /**
   * Omissis
   */
  WidgetDirectivesRepository.register(OmissisDirectiveType);
  /**
   * Modifica del campo in fase di integrazione
   */

  WidgetDirectivesRepository.register(IntegrableDirectiveType);
  /**
   * Coppie chiave/valore personalizzate.
   * Sempre registrata (i dati salvati restano validi ovunque);
   * la UI di configurazione è gestita via feature flag
   * `ENABLE_WIDGET_CUSTOM_PROPERTIES` dentro la direttiva stessa.
   */
  WidgetDirectivesRepository.register(CustomPropertiesDirectiveType);

  initThemeWidgetRepository();
};
